import React from "react";
import {observer} from "mobx-react";
import {Card, Col, Container, Row, Form, Button, Alert} from "react-bootstrap";
import rootStore from "../../stores/rootStore.js";
import HeroSection from "../../components/HeroSection.jsx";
import {useState} from "react";
import {useNavigate} from "react-router-dom";
import {accountApi} from "../../api/account.js";


function AccountPage() {
    const auth = rootStore.authenticationStore.authentication;
    const [firstName, setFirstName] = useState(auth?.firstName || "");
    const [lastName, setLastName] = useState(auth?.lastName || "");
    const [saving, setSaving] = useState(false);
    const [message, setMessage] = useState("");
    const [error, setError] = useState("");
    const navigate = useNavigate();

    const handleSave = async (e) => {
        e.preventDefault();
        setSaving(true);
        setError("");
        setMessage("");
        try {
            await accountApi.updateProfile(firstName, lastName);
            rootStore.authenticationStore.updateName(firstName, lastName);
            setMessage("Profile updated.");
        } catch (err) {
            setError("Could not update profile. Please try again.");
        } finally {
            setSaving(false);
        }
    };
    return (
        <Container className="dashboard-shell">
            <HeroSection
                accent="customer"
                eyebrow="Profile"
                title="Account & Profile"
                subtitle="Manage your account details and organization info."
            />
            <Row className="g-4 mt-1">
                <Col lg={6}>
                    <Card className="dashboard-panel">
                        <Card.Header className="bg-white">
                            <strong>Contact</strong>
                        </Card.Header>
                        <Card.Body>
                            {auth ? (
                                <Form onSubmit={handleSave}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>First Name</Form.Label>
                                        <Form.Control
                                            value={firstName}
                                            onChange={(e) => setFirstName(e.target.value)}
                                        />
                                    </Form.Group>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Last Name</Form.Label>
                                        <Form.Control
                                            value={lastName}
                                            onChange={(e) => setLastName(e.target.value)}
                                        />
                                    </Form.Group>
                                    <p className="mb-2"><strong>Username:</strong> {auth.username}</p>
                                    <p className="mb-0"><strong>Organization:</strong> {auth.orgName}</p>
                                    {message && <div className="text-success small mt-2">{message}</div>}
                                    {error && <Alert variant="danger" className="mt-2 mb-0 small">{error}</Alert>}
                                    <div className="d-flex justify-content-end mt-3">
                                        <Button type="submit" disabled={saving}>{saving ? "Saving..." : "Save"}</Button>
                                    </div>
                                </Form>
                            ) : (
                                <p className="text-muted mb-0">Loading profile...</p>
                            )}
                        </Card.Body>
                    </Card>
                </Col>
                <Col lg={6}>
                    <Card className="dashboard-panel">
                        <Card.Header className="bg-white"><strong>Security</strong></Card.Header>
                        <Card.Body>
                            <p className="mb-2"><strong>Role:</strong> {auth?.role || "-"}</p>
                            <p className="mb-2"><strong>Login Provider:</strong> {auth?.authProvider || "BCTC"}</p>
                            <div className="d-flex justify-content-between align-items-center mt-3">
                                <div>
                                    <div className="small text-muted">Change Password</div>
                                    <div className="text-muted small">
                                        {auth?.isExternalOnly
                                            ? "Password is managed by your external identity provider."
                                            : "Secure your account with a new password."}
                                    </div>
                                </div>
                                {!auth?.isExternalOnly && (
                                    <Button variant="outline-primary" onClick={() => navigate("/account/password")}>
                                        Change Password
                                    </Button>
                                )}
                            </div>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </Container>
    );
}

export default observer(AccountPage);
